export enum BannerTypeEnum {
	LOGIN = 1,
	HOME = 2,
	SUPPORTIVE_ENVIRONMENT = 3,
}
